/**
 * @generated SignedSource<<5b0ab788883e88494e30c6b2e70dcefc>>
 * @relayHash 9944371fde28df5702336aff3f633243
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9944371fde28df5702336aff3f633243

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type RedefineAppointmentServiceInput = {
  id: string;
  service: Service;
};
export type useRedefineAppointmentServiceMutation$variables = {
  input: RedefineAppointmentServiceInput;
};
export type useRedefineAppointmentServiceMutation$data = {
  readonly redefineAppointmentService: {
    readonly appointment: {
      readonly appointmentId: number;
      readonly appointmentType: AppointmentType;
      readonly assignedTo: string | null;
      readonly id: string;
      readonly service: Service;
      readonly specialty: ServiceSpecialty;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: "AppointmentNotFound";
      readonly message: string;
    } | {
      readonly __typename: "FeatureIsDisabledDuringDayLightSavingTime";
      readonly message: string;
    } | {
      readonly __typename: "PatientFileIsLocked";
      readonly message: string;
    } | {
      readonly __typename: "ServiceDoesNotAllowTheConsultationType";
      readonly message: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  };
};
export type useRedefineAppointmentServiceMutation = {
  response: useRedefineAppointmentServiceMutation$data;
  variables: useRedefineAppointmentServiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Appointment",
  "kind": "LinkedField",
  "name": "appointment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appointmentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedTo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "service",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "specialty",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = [
  (v3/*:: as any*/),
  (v4/*:: as any*/)
],
v6 = [
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRedefineAppointmentServiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RedefineAppointmentServicePayload",
        "kind": "LinkedField",
        "name": "redefineAppointmentService",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "AppointmentNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "PatientFileIsLocked",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "FeatureIsDisabledDuringDayLightSavingTime",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*:: as any*/),
                "type": "ServiceDoesNotAllowTheConsultationType",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useRedefineAppointmentServiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RedefineAppointmentServicePayload",
        "kind": "LinkedField",
        "name": "redefineAppointmentService",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "AppointmentNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "PatientFileIsLocked",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "FeatureIsDisabledDuringDayLightSavingTime",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v6/*:: as any*/),
                "type": "ServiceDoesNotAllowTheConsultationType",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9944371fde28df5702336aff3f633243",
    "metadata": {},
    "name": "useRedefineAppointmentServiceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ed79e9865a8f1a759073e42376ff5b0b";

export default node;
